import { Link } from "react-router-dom"
import SolutionsCard from "../common/SolutionsCard"
import { getBackgroundClass } from "../../utils/sectionHelpers";
import SectionTitle from "../common/SectionTitle";
import { useLocation } from "react-router-dom";

const ServicesSection = ({ data }) => {
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const settings = data?.Settings || {};

    const backgroundClass = getBackgroundClass(settings.background);
    return (
        <>
            <section className={`services-area ptb-70 ${backgroundClass}`}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <SectionTitle data={data} />
                        </div>
                    </div>


                    <div className="row justify-content-center gy-4 gx-lg-5">

                        <SolutionsCard data={data} />
                        {isHomePage && (

                            <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                                <div className="view-all-services">
                                    <Link to="#" onClick={(e) => e.preventDefault()} className="default-btn">
                                        <i className="flaticon-right"></i>
                                        View All Services <span className="default-btn-hover"></span>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>

        </>
    )
}

export default ServicesSection
